import { Component, Input, OnInit } from "@angular/core";
import { IObject } from "../../shared/models/models";
import { ServerService, IHistory } from "../../shared/services/server.service";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-log",
  templateUrl: "./log.component.html",
  styleUrls: ["./log.component.scss"]
})

export class LogComponent implements OnInit {

  public api = environment.apiUrl;
  
  @Input() object: IObject = null;

  loading: boolean = false;

  data: MyHistory[] = [];
  dataEx: MyHistory[] = [];

  blockTitles = ['Информация', 'Ход строительства', 'Финансирование', 'Реализация'];
  selectedBlock: string = 'Информация';

  selectedYear: number = new Date().getFullYear();
  years = [this.selectedYear - 1, this.selectedYear, this.selectedYear + 1];

  constructor(private server: ServerService) { }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.loading = true;
    this.server.getHistory(this.object.id).then(res => {
      this.loading = false;
      this.dataEx = this.updateData(res);
      this.data = this.dataEx.filter(d => d.blockTitle === this.selectedBlock).filter(d => new Date(d.updatedOn).getFullYear() === this.selectedYear);
    });
  }

  updateData(data: IHistory[]) {
    let res: MyHistory[] = data.map(r => {
      return {
        blockTitle: r.blockTitle,
        columnName: r.columnName,
        columnTitle: r.columnTitle,
        updatedOn: r.updatedOn,
        dataArr: []
      }
    }).filter((p, ix, arr) => {
      return arr.findIndex(p1 => p.columnName === p1.columnName) === ix;
    });

    res.forEach(r => {
      let dataArrEx = data.filter(d => d.columnName === r.columnName);
      r.dataArr = dataArrEx.map(dEx => {
        return {
          columnTitle: dEx.columnTitle,
          dbFileID: dEx.dbFileID,
          fileExtension: dEx.fileExtension,
          isFile: dEx.isFile,
          operType: dEx.operType,
          updatedOn: dEx.updatedOn,
          userMIOTitle: dEx.userMIOTitle,
          userName: dEx.userName,
          value: dEx.value
        }
      })
    });
    return res;
  }

  selectBlock(block) {
    this.selectedBlock = block;
    this.data = this.dataEx.filter(d => d.blockTitle === block).filter(d => new Date(d.updatedOn).getFullYear() === this.selectedYear);
  }

  selectYear(year) {
    this.selectedYear = year;
    this.selectBlock(this.selectedBlock);
  }

  selectPrev(){
   this.years.splice(2,1);
   this.years.unshift(this.years[0]-1);
  }

  selectNext(){
    this.years.splice(0,1);
    this.years.push(this.years[1]+1);
  }
  
  getActionTitle(operType: string) {
    switch (operType) {
      case 'I': return 'Добавлено';
      case 'U': return 'Обновлено';
      case 'D': return 'Удалено';
    }
    return;
  }

  downloadDocument(fileID: number, name: string) {
    this.server.downloadDocument(fileID).subscribe(response => {
      this.downLoadFile(response, name);
    });
  }

  downLoadFile(data: any, name: string) {
    let fileName = name.split('.')[0];
    var a = document.createElement("a");
    const blob = new Blob([data], { type: 'application/pdf' });

    a.href = URL.createObjectURL(blob);
    a.download = fileName;
    a.click();
  }

}


interface MyHistory {
  blockTitle: string;
  columnName?: string;
  columnTitle: string;
  updatedOn: string;
  dataArr: MyHistoryEx[];
}

interface MyHistoryEx {
  columnTitle: string;
  dbFileID: number;
  fileExtension: string;
  isFile: boolean;
  operType: string;
  updatedOn: string;
  userMIOTitle: string;
  userName: string;
  value: string;
}